import { getProductCardTemplate } from 'customAlgolia';


// const indexName = 'shopify_products'
const indexName = 'grafikr-com-products';

const getColor = (colorText) => {
  const color = colorText.toLowerCase();
  const colorMatch = window.genericSwatches[color];
  return colorMatch ? colorMatch : '#000';
};

document.addEventListener('DOMContentLoaded', () => {
  const {
    hits,
    searchBox,
    pagination,
    clearRefinements,
    refinementList,
    configure,
    stats,
    sortBy,
    currentRefinements,
    rangeSlider,
  } = window.instantsearch.widgets;

  //https://www.jsdelivr.com/package/npm/instantsearch.js
  const search = window.instantsearch({
    indexName: indexName,
    searchClient: window.searchClient,
    insights: true,
    routing: {
      router: instantsearch.routers.history(),
      stateMapping: instantsearch.stateMappings.simple()
    },
  });

  const refinementListCssClasses = {
    list: 'custom-refinement-list',
    item: 'custom-refinement-list__item',
    label: 'custom-refinement-list__label',
    labelText: 'custom-refinement-list__label-text',
    checkbox: 'custom-refinement-list__checkbox',
    count: 'custom-refinement-list__count',
  };

  const collectionHandleMatches = window.location.pathname.match(/\/collections\/([^/]+)/i);
  const collectionHandle = (collectionHandleMatches?.length === 2) ? collectionHandleMatches[1] : null;
  const collectionTitle = themeVariables.settings.collectionTitle || null;
  // const collectionHandle = 'Dresses';

  search.addWidgets([
    stats({
      container: '#stats',
      cssClasses: {
        text: 'text-gray-600',
      },
      templates: {
        text: `
          {{#hasNoResults}}${ window.themeVariables.strings.algolia.noResults }{{/hasNoResults}}
          {{#hasOneResult}}1 result{{/hasOneResult}}
          {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results{{/hasManyResults}}
        `,
      },
    }),

    hits({
      container: document.querySelector('#hits'),
      templates: {
        item(hit, { html, components }) {
          return html`${ getProductCardTemplate({ product: hit, index: hit.__position, queryID: hit.__queryID, quickAdd: true }) }`
        },
      },
      cssClasses: {
        item: 'product-card',
        list: 'product-list unstyled-list',
      },
    }),

    sortBy({
      container: '#sortBy',
      items: [
        { label: 'Featured', value: indexName },
        { label: 'Price (asc)', value: 'grafikr-com-products-price_asc' },
        { label: 'Price (desc)', value: 'grafikr-com-products-price_desc' },
        { label: 'Alphabetically, A-Z', value: 'grafikr-com-products-title_asc' },
        { label: 'Alphabetically, Z-A', value: 'grafikr-com-products-title_desc' },
        { label: 'Date, new to old', value: 'grafikr-com-products-published_at_desc' },
        { label: 'Date, old to new', value: 'grafikr-com-products-published_at_asc' },
      ],
      limit: 100,
    }),

    searchBox({
      container: '#searchbox',
      autofocus: true,
      placeholder: 'Search for products',
      searchAsYouType: false,
      cssClasses: {
        root: 'main-search-form',
        input: 'input',
        submit: 'searchbox__submit',
        reset: 'searchbox__reset',
        loadingIcon: 'searchbox__loading',
      },
    }),

    pagination({
      container: '#pagination',
      cssClasses: {
        root: 'h-stack justify-center gap-2',
        list: 'pagination',
        item: 'pagination__item',
        firstPageItem: 'pagination__link--first',
        lastPageItem: 'pagination__link--last',
        previousPageItem: 'pagination__link--previous',
        nextPageItem: 'pagination__link--next',
        pageItem: 'pagination__link--page',
        selectedItem: 'pagination__link--selected',
        disabledItem: 'pagination__link--disabled',
        link: 'pagination__link h6',
      },
    }),

    clearRefinements({
      container: '#clear-refinements',
      cssClasses: {
        button: 'removable-facet clear-refinements',
      },
    }),

    refinementList({
      container: '#refinement-list-category',
      attribute: 'custom.category',
      sortBy: ['name:asc'],
      cssClasses: refinementListCssClasses,
      limit: 100
    }),

    refinementList({
      container: '#refinement-list-prodduct-type',
      sortBy: ['name:asc'],
      attribute: 'custom.sub-cat',
      cssClasses: refinementListCssClasses,
      limit: 100
    }),

    refinementList({
      container: '#refinement-list-style',
      sortBy: ['name:asc'],
      attribute: 'custom.style',
      cssClasses: refinementListCssClasses,
      limit: 100
    }),

    refinementList({
      container: '#refinement-list-colour',
      sortBy: ['name:asc'],
      attribute: 'custom.colourName',
      cssClasses: refinementListCssClasses,
      limit: 100,
      templates: {
        item: (item) => `
        <input type="checkbox" class="sr-only" ${ item.isRefined ? 'checked' : '' } />
        <label class="color-swatch   rounded-full " data-tooltip="${ item.label }" style="--swatch-background: ${ getColor(item.label) }">
        <span class="sr-only">${ item.label }</span>
        </label>
      `,
      },
    }),

    refinementList({
      container: '#refinement-list-size',
      sortBy: ['name:asc'],
      attribute: 'options.values',
      cssClasses: refinementListCssClasses,
      limit: 100
    }),

    refinementList({
      container: '#refinement-list-occasion',
      sortBy: ['name:asc'],
      attribute: 'custom.occasion',
      cssClasses: refinementListCssClasses
    }),

    rangeSlider({
      container: document.querySelector('#range-slider-price'),
      attribute: 'price',
      step: 100,
    }),

    currentRefinements({
      container: '#current-refinements',
      cssClasses: {
        root: 'current-refinements gap-3 h-stack wrap',
        list: 'current-refinements__list unstyled-list',
        item: 'active-facets',
        label: 'hidden',
        category: 'removable-facet',
        delete: 'current-refinements__delete',
        clear: 'current-refinements__clear',
      },
    }),

    // https://www.algolia.com/doc/api-reference/search-api-parameters/
    configure({
      hitsPerPage: window.customAlgoliaConfig.hitsPerPage || 12,
      query: window.customAlgoliaConfig.currentQuery || '',
      distinct: true,
      facetingAfterDistinct: true,
      clickAnalytics: true,
      enablePersonalization: true,
      // filters: collectionHandle ? `collections.titles:${ collectionHandle }` : '',
      filters: collectionHandle ? `collections.titles:"${collectionTitle}"` : '',
    }),
  ]);

  search.start();
});
